var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"bg-gray-300 mx-4 p-3",on:{"click":_vm.printToPOS}},[_vm._v("Print")])])
}
var staticRenderFns = []

export { render, staticRenderFns }